import { ImageResponse } from "next/og";

export const alt = "Dev Cubix — Full-Stack Digital Agency";
export const size = { width: 1200, height: 630 };
export const contentType = "image/png";

export default function Image() {
  return new ImageResponse(
    (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0A0A0A",
          position: "relative",
        }}
      >
        {/* Red gradient accent */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #E11D24, #FF4D53, #E11D24)",
          }}
        />

        {/* Logo cube */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "80px",
            height: "80px",
            backgroundColor: "#E11D24",
            borderRadius: "16px",
            marginBottom: "32px",
          }}
        >
          <span
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#FFFFFF",
            }}
          >
            DC
          </span>
        </div>

        {/* Title */}
        <div
          style={{
            fontSize: "52px",
            fontWeight: 700,
            color: "#FFFFFF",
            textAlign: "center",
            lineHeight: 1.2,
            marginBottom: "16px",
          }}
        >
          Dev Cubix
        </div>

        {/* Subtitle */}
        <div
          style={{
            fontSize: "24px",
            color: "#A0A0A0",
            textAlign: "center",
            maxWidth: "800px",
          }}
        >
          Full-Stack Digital Agency — UI/UX, Web Dev, Design, AI
        </div>

        {/* Stats row */}
        <div
          style={{
            display: "flex",
            gap: "48px",
            marginTop: "40px",
          }}
        >
          {[
            { num: "190+", label: "Projects" },
            { num: "50+", label: "Clients" },
            { num: "40+", label: "Team" },
          ].map((stat) => (
            <div
              key={stat.label}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "32px", fontWeight: 700, color: "#E11D24" }}>
                {stat.num}
              </span>
              <span style={{ fontSize: "16px", color: "#666666" }}>{stat.label}</span>
            </div>
          ))}
        </div>

        {/* URL */}
        <div
          style={{
            position: "absolute",
            bottom: "24px",
            fontSize: "16px",
            color: "#444444",
          }}
        >
          devcubix.com
        </div>
      </div>
    ),
    { ...size }
  );
}
